import clsx from 'clsx'
import { TypographyParagraph } from '../typography'
import {
	CalloutErrorIcon,
	CalloutHelpIcon,
	CalloutSuccessIcon,
	CalloutWarningIcon,
	CloseIcon,
	ArrowRightIcon,
	LoadingIcon,
} from '../icons'
import UploadImage from '../icons/Actions/UploadImageIcon'
import Button from '../buttons/button'

const Toast = ({
	variant = 'help',
	content,
	additionalClasses = '',
	onClose,
	textCTA,
	onClickCTA,
	...props
}: {
	variant: 'help' | 'error' | 'success' | 'warning' | 'uploading' | 'loading'
	content: string
	additionalClasses?: string
	onClose?: () => void
	textCTA?: string
	onClickCTA?: () => void
}) => {
	return (
		<div
			className={clsx(
				variant === 'error' &&
					'border border-solid border-uiPrimaryLight bg-white dark:border dark:border-solid dark:border-uiSecondaryDark dark:bg-uiTertiaryDark',
				variant === 'help' &&
					'bg-[#F7F7FF] dark:border dark:border-solid dark:border-[#4B4BFF] dark:bg-black',
				variant === 'success' &&
					'bg-[#F5FFF5] dark:border dark:border-solid dark:border-[#008A0D] dark:bg-black',
				variant === 'warning' &&
					'bg-[#F5F5F5] dark:border dark:border-solid dark:border-[#D47307] dark:bg-black',
				'relative flex items-start rounded-md p-3',
				(variant === 'uploading' || variant === 'loading') &&
					'bg-[#F5F5F5] dark:border dark:border-solid dark:border-grey400 dark:bg-black',
				'relative flex items-start rounded-md p-3',
				additionalClasses,
			)}
			{...props}
		>
			<div className="min-w-5">
				{variant === 'error' && <CalloutErrorIcon />}
				{variant === 'help' && <CalloutHelpIcon />}
				{variant === 'success' && <CalloutSuccessIcon />}
				{variant === 'warning' && <CalloutWarningIcon />}
				{variant === 'uploading' && <UploadImage />}
				{variant === 'loading' && (
					<div className="animate-spin">
						<LoadingIcon className="text-textSecondaryLight dark:text-textSecondaryDark" />
					</div>
				)}
			</div>
			<div>
				<TypographyParagraph
					size="small"
					additionalClasses="ml-3 mr-10 text-textPrimaryLight dark:text-textPrimaryDark break-words"
				>
					{content}
				</TypographyParagraph>
				{onClickCTA && textCTA && (
					<Button
						variant="tertiary"
						size="xSmall"
						additionalClasses="ml-3 mt-2"
						onClick={onClickCTA}
						leftIcon={<ArrowRightIcon size="small" />}
					>
						{textCTA}
					</Button>
				)}
			</div>
			{onClose && (
				<div className="text-textSecondaryLight dark:text-textSecondaryDark">
					<CloseIcon onClick={() => onClose()} />
				</div>
			)}
			{variant === 'error' && (
				<div className="absolute bottom-0 left-0 h-1 w-full rounded-b-md bg-[#FF3131] dark:bg-[#FF6F6F]"></div>
			)}
			{variant === 'help' && (
				<div className="absolute bottom-0 left-0 h-1 w-full rounded-b-md bg-[#4B4BFF] dark:bg-[#7676FC]"></div>
			)}
			{variant === 'success' && (
				<div className="absolute bottom-0 left-0 h-1 w-full rounded-b-md bg-[#1AB51A] dark:bg-[#33DF64]"></div>
			)}
			{variant === 'warning' && (
				<div className="absolute bottom-0 left-0 h-1 w-full rounded-b-md bg-[#EFB615] dark:bg-[#FFDF36]"></div>
			)}
			{(variant === 'uploading' || variant === 'loading') && (
				<div className="absolute bottom-0 left-0 h-1 w-full rounded-b-md bg-grey400 dark:bg-textSecondaryDark"></div>
			)}
		</div>
	)
}

export default Toast
